import XLSX from 'xlsx'

class SheetExporter {
  constructor (source) {
    // available formats
    this.FORMAT = {}
    this.FORMAT.CSV = 'csv'
    this.FORMAT.XLSX = 'xlsx'

    this.source = source
    this.headers = this.computeFileHeaders()
    this.table = this.computeTable()
    this.workbook = this.createWorkbook()
  }

  export (format, filename) {
    const _filename = `${filename || 'Export'}.${(format)}`
    if (format === this.FORMAT.CSV) {
      // Todo: export
    } else if (format === this.FORMAT.XLSX) {
      // Todo: export
    } else {
      throw new Error('Invalid export format specified!')
    }
    return XLSX.writeFile(this.workbook, _filename)
  }

  // Private members
  computeFileHeaders () {
    const source = this.source
    let headers = []
    for (let element of source) {
      for (let key of Object.keys(element)) {
        headers.push(key)
      }
    }
    return [...new Set(headers)]
  }

  computeTable () {
    const headers = this.headers
    const source = this.source
    let table = [headers]
    for (let element of source) {
      let row = []
      for (let key of headers) {
        if (element[key]) {
          row.push(element[key])
        } else {
          row.push('')
        }
      }
      table.push(row)
    }
    return table
  }

  createWorkbook () {
    const wb = XLSX.utils.book_new()
    const ws = XLSX.utils.aoa_to_sheet(this.table)
    XLSX.utils.book_append_sheet(wb, ws, 'Export')
    return wb
  }
}

export default SheetExporter



// WEBPACK FOOTER //
// ./src/models/SheetExporter.js